// extracted by mini-css-extract-plugin
export default {"container":"AuthFailScreen_container__181yb","iconWrap":"AuthFailScreen_iconWrap__EZMOe","title":"AuthFailScreen_title__nSTDU","message":"AuthFailScreen_message__d6g58"};